import './editble-table.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox'
import { t } from 'react-multi-lang';
import { AddBox, Delete ,ContentCopy} from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import {Tooltip  } from '@mui/material';
import Grid from '@mui/material/Grid'
import { SmartInput } from '../FormElements/FormElements';

interface iOptions {
  [key: string]: any;
}

interface iTouched {
  [key: string]: any;
}
export interface EditableTableProps {
  headers: any[];
  values: {[key:number]:any};
  handleChange: (e: React.ChangeEvent, index: number) => void;
  selectInput?: string[];
  options?: iOptions;
  addLine?: Function;
  removeLine?: (line_number:string[])=>void;
  handleBlur?: Function;
  error: any;
  touched: iTouched;
  array_name: string;
  has_general_options?: boolean;
  lines_number: number;
  number_inputs?: undefined | string[];
  maxHeight?: string;
  copyLine?:(line_number:string[])=>void,
  spans?:{[key:string]:number},
  units?:{[key:string]:string}
}
const EditbleTable = ({
  headers,
  values,
  handleChange,
  selectInput,
  options,
  addLine,
  removeLine,
  touched,
  error,
  array_name,
  has_general_options,
  lines_number,
  number_inputs,
  maxHeight,
  handleBlur,
  copyLine,
  spans,
  units

}: EditableTableProps) => {
  const tabel = useRef(null);
  const [selected_rows,setSelectRow]=useState<number[]>([])

  useEffect(() => {
    if (tabel.current) {
      (tabel.current as HTMLDivElement).scroll({
        behavior: 'smooth',
        top: (tabel.current as HTMLDivElement).children[0].scrollHeight,
      });
    }
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent the default Tab behavior

      // Invert the focus direction
      const focusableElements = document.querySelectorAll('.tab_element');
      const focusableArray = Array.from(focusableElements);

      const currentIndex = focusableArray.indexOf(document.activeElement!!);
      const nextIndex =
        currentIndex === 0 && focusableArray ? focusableArray?.length - 1 : currentIndex - 1;
       
        if (focusableArray[nextIndex].tagName === 'INPUT' ){

          (focusableArray[nextIndex] as HTMLInputElement).focus();
        }
        if (focusableArray[nextIndex].tagName === 'SELECT' ){
          (focusableArray[nextIndex] as HTMLInputElement).focus();
          (focusableArray[nextIndex] as HTMLSelectElement).click();
        }
    }
  };

  const actions=({show,i,head_row}:{show:boolean,i:string,head_row:boolean})=>  { 
  

    return ( 
    <>
        <Checkbox 
                          className='table_checkbox'
                          checked={head_row?
                            selected_rows.length===Object.keys(values).length && (Object.keys(values).length !==0)?
                            true:false
                            :selected_rows.includes(parseInt(i))}
                          onClick={()=>setSelectRow(pre=>{
                            let new_array:number[]=[]
                            if (head_row) {
                             
                              new_array=Object.keys(values).map(ele=>parseInt(ele))
                              if (new_array.length===selected_rows.length){
                                new_array=[]
                              }
                            
                            }
                            else {
                              if  ( pre.includes(parseInt(i))){
                              new_array=pre.filter(ele=> ele !== parseInt(i))
                              }
                              else {
                                new_array=[...pre,parseInt(i)]
                              }
                          }
                            return new_array
                          })}
                        />

    
        <>
                        { removeLine &&
                          <IconButton onClick={() => {
                            if (head_row) {
                              setSelectRow(pre=>[])
                              removeLine(selected_rows.map(ele=>ele.toString()))
                            }
                            else {
                              setSelectRow(pre=>[])
                              removeLine([i])
                            }
                          }
                        
                          }
                      
                          sx={{
                            padding:'0px',
                            transition:'transform 1s ease',
                            visibility:!show?'collapse':'visible',
                          
                            '&:hover':{
                              transform:'scale(1);',
                              background:'lightgray',
                              
                              
                            }
                          }}
                          >
                            <Delete color="error" sx={{width:'20px',height:'25.2px'}} />
                          </IconButton>}
                          {copyLine &&
                              <IconButton onClick={() =>{
                                if (head_row) {
                                  copyLine(selected_rows.map(ele=>ele.toString())) 
                                  setSelectRow(pre=>[])
                                }
                                else {
                                  copyLine([i])
                                  setSelectRow(pre=>[])
                                }
                              }
                                
                              }
                            
                              sx={{
                                padding:'0px',
                                transition:'transform 1s ease',
                                visibility:!show?'collapse':'visible',
                            
                                '&:hover':{
                                  transform:'scale(1);',
                                  background:'lightgray'
                                  
                                }
                              }}
                              >
                                <ContentCopy color='primary' sx={{width:'20px',height:'25.2px'}}/>
                              </IconButton>
                          } 
                          </>
                          
                      
        </>
      

      )
    }


  return (
    <Grid  container  size={12}>
      <Grid  container size={12}>
        <TableContainer
          component={Paper}
          className="editbleTable"
          ref={tabel as any}
          style={{ paddingTop: '0', maxHeight }}>
          <Table sx={{ minWidth: 650 }} stickyHeader={true}>
            <TableHead>
              <TableRow sx={{
                 "& .MuiTableCell-root": {
                      padding: "5px",
                      fontSize: "13px",
                     
                    },
              }}>
                <TableCell 
                style={{whiteSpace:'nowrap',verticalAlign:'center'}}>
                  {actions({show:selected_rows.length>0
                       ,i:'all',head_row:true})}
                </TableCell>
                {headers.map((ele: string | Element, index: number) => (
                  <TableCell align="right" key={`${ele}${index}`}
                  // colSpan={spans&& typeof(ele)==='string'&& spans[ele]?spans[ele]:1}
                  >
                    {ele + `${units&& typeof(ele)==="string" && units[ele]? ` ${units[ele]} ` : ''}`}
                    
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody style={{ position: 'relative' }}>
              {Object.keys(values).map((i, index) => (
                <TableRow
                  key={i}
                  style={{
                  
                    width: '100%',
                  }}
                  sx={{
               
                     
                 "& .MuiTableCell-root": {
                      padding: "1px",
                      fontSize: "13px",
                       lineHeight:'normal',
                      
                   

                    },
              }}
                    
               
                  >
                   
                  {
                  ( Object.keys(values)?.length > 0) ? (
                    <TableCell style={{whiteSpace:'nowrap',verticalAlign:'center'}} 

                   
                    >
                    {
                      actions({show:selected_rows.length===0,i:i,head_row:false})
                    }
                      
                    </TableCell>
                    
                  ) : (
                    <TableCell ></TableCell>
                  )}
                  
                  {Object.keys(values[Number(i)]).map((elem: string, index: number) => {

                   let not_valid =   (error[array_name]&& touched[array_name])&&
                                  (  error[array_name][Number(i)]&&touched[array_name][Number(i)])&&
                                  error[array_name][Number(i)][elem] && touched[array_name][Number(i)][elem]
                    
                                 

                    if (selectInput?.includes(elem)) {
                     
                      return (
                            <Tooltip
                           open={false}
                           title={error[array_name]&& error[array_name][Number(i)]?
                            error[array_name][Number(i)][elem]:''
                           }
                           sx={{
                            color:'red'
                           }}
                            key={index}
                          >
                        
                        <TableCell
                          key={index}
                          // colSpan={spans&& typeof(elem)==='string'&& spans[elem]?spans[elem]:1}
                         
                          sx={{
                            borderColor: 'lightgray',
                            borderLeft: '1px solid lightgray',
                            borderLeftStyle: 'groove',
                               padding:'0px',
                            border: 
                            array_name?
                            not_valid?
                          "1px solid red":''
                       
                       
                          :''
                          
                          }}>
                        
                          <select
                               onKeyDown={handleKeyDown}
                          style={{minWidth:'190px'}}
                            value={values && values[Number(i)] ? 
                               number_inputs?.includes(elem)?
                               parseInt(values[Number(i)][elem]):
                              values[Number(i)][elem] : ''}
                            className={`select tab_element ${array_name?
                              not_valid?
                          "inValid":''
                       
                          :''
                              
                            }`}
                            name={
                              array_name
                                ? `${array_name}[${i}][${elem}]`
                                : `[${i}][${elem}]`
                            }
                            onChange={(e: React.ChangeEvent) => {
                              handleChange(e, parseInt(i));
                            }}>
                            <>
                              <option value="">{t('select...')}</option>
                              {options && options[elem]
                                ? !has_general_options
                                  ? options[elem].map((ele: any, j: number) => {
                                      return (
                                        <option
                                          value={ele.value ? ele.value : ''}
                                          key={'options[elem]' + j}>
                                          {ele.name ? ele.name : ''}
                                        </option>
                                      );
                                    })
                                  : options[elem] && options[elem][i]
                                  ? options[elem][i].map(
                                      (ele: any, j: number) => {
                                        return (
                                          <option
                                            value={ele.value ? ele.value : ''}
                                            key={'options[elem][i]' + j}>
                                            {ele.name ? ele.name : ''}
                                          </option>
                                        );
                                      },
                                    )
                                  : options[elem]['general'] &&
                                    options[elem]['general']?.length > 0
                                  ? options[elem]['general'].map(
                                      (ele: any, j: number) => {
                                        return (
                                          <option
                                            value={ele.value ? ele.value : ''}
                                            key={'options[elem][general' + j}>
                                            {ele.name ? ele.name : ''}
                                          </option>
                                        );
                                      },
                                    )
                                  : ''
                                : ''}
                            </>
                          </select>
                        </TableCell>
                          </Tooltip>
                      );
                    }
                    
                    return (
                        <Tooltip
                          
                           title={error[array_name]&& error[array_name][Number(i)]?
                            error[array_name][Number(i)][elem]:''
                           }
                           slotProps={{
                            tooltip:{
                              sx:{
                          
                              background:'white',
                              color:'red',
                              border:'1px solid red'
                              }
                            }
                           }}

                            key={elem + `${index}`}
                        
                          >
                      <TableCell
                      
                        key={elem + `${index}`}
                        sx={{
                          borderColor: 'lightgray',
                          borderLeft: '1px solid  lightgray',
                          borderLeftStyle: 'groove',
                          padding: '0px',
                          border:array_name?
                            not_valid?
                          "1px solid red":''
                       
                          :''
                        }}>
                        

                            <SmartInput
                              type={
                                number_inputs
                                  ? number_inputs.filter((number_input) =>
                                      array_name && array_name !== 'dummy'
                                        ? `${array_name}[${i}][${elem}]`.includes(
                                            number_input,
                                          )
                                        : `[${i}][${elem}]`.includes(number_input),
                                    )?.length > 0
                                    ? 'number'
                                    : 'text'
                                  : 'text'
                              }
                              onKeyDown={handleKeyDown}
                              className={`input tab_element  table_input ${
                                array_name?
                                not_valid?
                                "inValid":''
                            
                                :''
                                
                              }`}
                              name={
                                array_name && array_name !== 'dummy'
                                  ? `${array_name}[${i}][${elem}]`
                                  : `[${i}][${elem}]`
                              }
                              key={index}
                              onBlur={handleBlur?handleBlur as any :undefined}
                              contentEditable={true}
                              onChange={(e: React.ChangeEvent) =>
                                handleChange(e, parseInt(i))
                              }
                              value={values && values[Number(i)] ? values[Number(i)][elem] : ''}
                            />
                      </TableCell>
                          </Tooltip>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid
        
        container
        size={12}
        style={{ position: 'relative' }}
        className="tableAction">
        {addLine && (
          <IconButton className="addIcon" onClick={() => addLine()}>
            <AddBox />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default EditbleTable;
